const chi = {
  "joinNow": {
    "who_are_you": {
      "pageTitle": "立即加入",
      "title": "你是誰？ 我們想更好地了解你。",
      "option": ['創作者', '投資者', '天賦'],
      "nextButton": '下一個'
    },
  'create_new_account': {
    "pageTitle": "創建一個新帳戶。",
    "titleA": "來加入我們的社區吧！讓我們設置你的帳戶。",
    "titleB":"已經有了？",
    "signinButton":"在這裡登錄",
    "lastText": "提交表單即表示您同意我們的。",
    "termsOfService": "C服務條款",
    "nextButton": "下一個",
    "OR": "或",
    "form": {
      "email": "電子郵件",
      "companyEmail": "公司郵箱",
      "password": "密碼",
      "name": "N全名",
      "userType": "選擇用戶類型",
      "country": "居住地",
      "companyName": "公司名稱",
      "companyAddress": "公司地址",
      "dob": "出生日期",
      "typeOptions": ["個人投資者", "組織"],
      "role": "role",
    }
  }
  },
  "tagsView": {
  "project": {
    "pageTitle": "你對什麼樣的項目感興趣？",
      "title": "這將使我們能夠根據您的興趣向您展示最佳匹配。",
      "tags":{
      'TV Drama': '電視劇',
        'Animations': '動畫',
        'Other': '其他',
        'Indie Shorts': '獨立短褲',
        'Feature Films': '故事片',
        'Documentaries': '紀錄片',
        'Anime':'動漫'
    }
  },
  "geography": {
    "pageTitle": "您對哪些地區的融資感興趣？",
      "title": "這將使我們能夠根據您的興趣向您展示最佳匹配。",
      "tags":{
      'United Kingdom': '英國',
        'India': '印度',
        'Nigeria': '尼日利亞',
        'Europe':  '尼日利亞',
        'China': '中國',
        'South Korea': '韓國',
        'United States':  '美國',
        'Other': '其他'
    }
  },
  "nextButton": "下一個",
    "backButton": "返回",
    "label": "標籤"
}
}
/*
*
* "pageTitle": "創建一個新帳戶。",
       "titleA": "來加入我們的社區吧！讓我們設置你的帳戶。",
       "titleB":"已經有了？",
       "signinButton":"在這裡登錄",
       "lastText": "提交表單即表示您同意我們的。",
       "termsOfService": "服務條款",
       "nextButton": "下一個",
       “或”：“或”，
       “形式”： {
         “電子郵件”：“電子郵件”，
         "companyEmail": "公司郵箱",
         "密碼": "密碼",
         "name": "全名",
         "userType": "選擇用戶類型",
         “國家”：“居住地”，
         "companyName": "公司名稱",
         "companyAddress": "公司地址",
         "dob": "出生日期",
         "typeOptions": ["個人投資者", "組織"]
       }
*
* */
module.exports = chi;